import { CurrencyIcon } from '@components'
import SelectedIcon from '@icons/password-terms-check.svg?react'
import cn from '@integrations/classnames'
import type { SyntheticEvent } from '@integrations/react'
import { uiSize } from '@utils'
import styles from './CurrencyBadge.module.scss'

interface Props {
  currencyCode: string
  isSelected: boolean
  onClick: (e: SyntheticEvent) => void
}

function CurrencyBadge({ currencyCode, isSelected, onClick }: Props) {
  return (
    <div
      className={cn(styles['currency-badge-wrapper'], 'currency-badge-wrapper', {
        [styles['selected']]: isSelected,
        selected: isSelected
      })}
      onClick={onClick}
    >
      <div>
        <CurrencyIcon currency={currencyCode} circle size={uiSize(22)} />
      </div>
      <span data-test='currency' className={cn(styles['currency-name'], 'currency-name')}>
        {currencyCode}
      </span>
      {isSelected && <SelectedIcon />}
    </div>
  )
}

export default CurrencyBadge
